import IndexPage from 'flarum/forum/components/IndexPage';
import PageStructure from 'flarum/forum/components/PageStructure';
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import WidgetManager from '../common/WidgetManager';
import EndWidgetSection from './components/EndWidgetSection';
import StartTopWidgetSection from './components/StartTopWidgetSection';
import StartBottomWidgetSection from './components/StartBottomWidgetSection';
import TopWidgetSection from './components/TopWidgetSection';
import BottomWidgetSection from './components/BottomWidgetSection';
app.widgets = new WidgetManager().addPage(IndexPage);
app.initializers.add('fof/forum-widgets-core', () => {
  app.widgets.setConfig(app.data.resources[0]?.attributes['fof-forum-widgets-core.config'] ?? {});
  extend(PageStructure.prototype, 'mainItems', function (items) {
    items.add('topWidgetSection', m(TopWidgetSection, null), 15);
    items.add('bottomWidgetSection', m(BottomWidgetSection, null), 5);
  });
  extend(PageStructure.prototype, 'containerItems', function (items) {
    items.add('endWidgetSection', m(EndWidgetSection, null), 1);
  });

  // Beside the page's sidebar (the index nav), not inside its list: on phones core moves that
  // list's header controls into the header, and with more than one of them the list itself.
  extend(PageStructure.prototype, 'sidebarItems', function (items) {
    items.add('startTopWidgetSection', m(StartTopWidgetSection, null), 110);
    items.add('startBottomWidgetSection', m(StartBottomWidgetSection, null), 90);
  });
});

// Allow flarum to discover modules
import './forum';
// @ts-ignore